import { useStore } from "../store";
import { ItemContainer } from "./ItemContainer";
import { BroadcastItem } from "./BroadcastItem";

export function BroadcastItems() {
  const { broadcasts, viewHiddenBroadcasts } = useStore();

  return (<>
    <ItemContainer>
      {
        broadcasts.filter(b => viewHiddenBroadcasts || !b.deleted)
          .sort((a, b) => a.broadcastStartTime - b.broadcastStartTime)
          .map((b, i) => <BroadcastItem key={ b.id } index={ i } broadcast={ b }/>)
      }
    </ItemContainer>
  </>);
}
